import React from 'react';

import { withTranslation, WithTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-types-papi';
import { Url, USER_PROFILE_POSTS_SUB_PATHS } from '@wix/da-url';
import { MeasuredSlider as Slider } from '@wix/da-shared-react/pkg/Slider';
import DuperbrowseContext from '../../../../../contexts/DuperbrowseContext';
import SwipeSlider from '@wix/da-shared-react/pkg/SwipeSlider';
import WidgetBox, {
  Props as WidgetBoxProps,
} from '../../../../UserWidgets/_partials/WidgetBox';
import StandardThumb from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Standard';
import EmptyState from '../../_partials/EmptyState';
import PostEditableItem from '../../../../UserWidgets/_partials/PostEditableItem';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import { withMobileContext } from '@wix/da-shared-react/pkg/Context/MobileContext';

import s from '../PostsAll.scss';

export interface Props {
  streamId: string;
  moduleId: number;
  journals: PapiDeviation[];
  total: number;
  ownerUsername: string;
  isMobile?: boolean;
}

export class JournalSlider extends React.Component<
  Props & WidgetBoxProps & WithTranslation
> {
  render() {
    const {
      t,
      widgetMoveUp,
      widgetMoveDown,
      widgetRemove,
      moduleId,
      journals,
      total,
      ownerUsername,
      isMobile,
      streamId,
      section,
      zone,
    } = this.props;
    const isEmpty = !journals.length;
    return (
      <WidgetBox
        section={section}
        zone={zone}
        header={t!('common.journals_plural')}
        count={total}
        moduleId={moduleId}
        isEmpty={isEmpty}
        hasMore={!isEmpty} // until we implement inner slider overflow recognition
        emptyView={
          <EmptyState
            className={s['empty-state-journal']}
            view="wide"
            postType="journal"
            CTAButtonModalType={ModalType.JOURNAL}
          />
        }
        seeAllUrl={Url.userPostsPath({
          username: ownerUsername,
          subPath: USER_PROFILE_POSTS_SUB_PATHS.JOURNALS,
        })}
        widgetMoveUp={widgetMoveUp}
        widgetMoveDown={widgetMoveDown}
        widgetRemove={widgetRemove}
      >
        <DuperbrowseContext
          streamId={streamId}
          deviations={journals}
          parent={{ title: ownerUsername }}
        >
          {isMobile ? (
            <SwipeSlider>
              {journals.map(journal => (
                <PostEditableItem key={journal.deviationId} item={journal}>
                  <StandardThumb
                    deviation={journal}
                    height={343}
                    responsive={true}
                  />
                </PostEditableItem>
              ))}
            </SwipeSlider>
          ) : (
            <Slider
              renderSliderItems={elementSize =>
                journals.map(journal => (
                  <PostEditableItem key={journal.deviationId} item={journal}>
                    <StandardThumb
                      deviation={journal}
                      width={elementSize.width}
                      height={elementSize.height}
                      responsive={false}
                    />
                  </PostEditableItem>
                ))
              }
            />
          )}
        </DuperbrowseContext>
      </WidgetBox>
    );
  }
}

export default withMobileContext(withTranslation()(JournalSlider));
